<script>
  import StoryblokClient from "storyblok-js-client";

  let accessToken = __myapp.env.STORYBLOK_KEY;

  let Storyblok = new StoryblokClient({
    accessToken
  });

  async function get() {
    const res = await Storyblok.get("cdn/stories", {
      starts_with: "blog/"
    });
    console.log(res);
    return res;
  }

  let promise = get();
</script>

<svelte:head>
  <title>Blog - CodeWorld</title>
</svelte:head>

<div class="container">
  <div class="section text-center">
    <div class="card card-body">
      {#await promise}
        loading
      {:then data}
        <h1>Blog Posts</h1>
        <span class="inline-grid lg:grid-cols-3 gap-x-4">
          {#each data.data.stories as story}
            <div class="prose border-none filter drop-shadow-lg ">
              <a href={story.full_slug}><h1>{story.name}</h1></a>
              <div class="mx-auto">{story.content.intro}</div>
            </div>
          {/each}
        </span>
      {:catch error}
        failed with {error}
      {/await}
    </div>
  </div>
</div>
